module.exports = __webpack_public_path__ + "img/Easy-connection.4ce01cb8.png";